import styled from "styled-components";

const PopoverWrapper = styled.div`
  position: relative;
  cursor: pointer;

  .popover-handler {
    display: inline-block;
    cursor: pointer;
    
    .burger-menu {
      display: flex;
      color: #fff;
      background-color: #9cc54b;
      width: 70px;
      height: 70px;
      align-items: center;
      justify-content: center;
      position: relative;
      
      &.express { background-color: #f01266; }
      
      svg {
        width: 3rem;
        height: 3rem;
        position: relative;
        top: -0.5rem;
      }
      .menu-link {
        font-size: 0.8rem;
        line-height: 0.8rem;
        position: absolute;
        bottom: 0.7rem;
      }
    }
  }

  .popover-content {
    display: block;
    min-width: 200px;
    padding: 15px 20px;
    position: absolute;
    border-radius: 6px;
    background-color: #ffffff;
    box-shadow: 0 3px 20px rgba(142, 142, 142, 0.14);
    z-index: 99;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
     &.active {
        opacity: 1;
        pointer-events: all;
        visibility: visible;
    }
    &:before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 8px 9px 8px;
      border-color: transparent transparent #ffffff transparent;
      top: -8px;
      left: 15px;
      box-shadow: -4px -4px 8px -3px rgba(142, 142, 142, 0.14);
      pointer-events: none;
    }
    
    /* &.express { top: calc(100%); } */
    &.no-pd { padding-bottom: 0 !important; }
    &.express:before { display: none; }
    
    .flex-box {
      width: 100%;
      min-width: 310px;
      background-color: rgb(217 217 217 / 34%);
      padding: 20px 0;
      margin-top: -20px;
      
      .link-back-to-normal-shop {
        width: 100%;
        max-width: 230px;
        margin: 0 auto;
        padding: 10px 30px 10px 5px;
        display: flex;
        align-items: center;
        border: 1px solid #e7e7e7;
        border-radius: 25px;
        gap: 15px;
        
        .logo {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        span { font-weight: bold; }
        img { flex: 1; }
      }
    }
  }


  .bg_express {
    width: calc(100vw - 20px);
    /* width: 400px; */
    height: 100vh;
    position: fixed ;
    top:0;
    left: 0;
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    /* display: none; */
    background-color: rgb(0,0,0,0.4);
    transition: all 0.4s ease-in-out;

    &.active {
        opacity: 1;
        pointer-events: all;
        visibility: visible;
        /* display: inline-block; */
    }
    .express-bg2{
      position: relative;
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease-in-out;
      background-color: rgb(0,0,0, 0.4);
      &.active {
          opacity: 1;
          pointer-events: all;
          visibility: visible;
      }
    }

  .express-content {
    position: absolute;
    left: 0;
    top: 0;
    /* top: calc(100% + 15px); */
    display: block;
    width: 0;
    height: 0;
    /* padding: 15px 20px; */
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    /* background-color: #f01266; */
    background-color: rgb(255 255 255 / 100%);
    /* box-shadow: 0 3px 20px rgba(142, 142, 142, 0.14); */
    z-index: 99;
    /* background: red; */
    transform-origin: top left;
    transform: translateZ(0);
    transition: all 0.3s ease-in-out;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;

    &.active {
        transform: translate(-50%,-50%);
        width: 400px;
        height: 400px;
        top: 50%;
        left: 50%;
        opacity: 1;
        pointer-events: all;
        visibility: visible;
    }
    
    &.express { top: calc(100%); }
    &.no-pd { padding-bottom: 0 !important; }
    &.express:before { display: none; }
    
    .flex-box {
      width: 100%;
      min-width: 310px;
      /* background-color: rgb(217 217 217 / 100%); */
      
      .link-back-to-normal-shop {
        width: 100%;
        max-width: 230px;
        margin: 0 auto;
        padding: 10px 30px 10px 5px;
        display: flex;
        align-items: center;
        border: 1px solid #e7e7e7;
        border-radius: 25px;
        gap: 15px;
        
        .logo {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        span { font-weight: bold; }
        img { flex: 1; }
      }
    }
  }
}

  /* If direction prop set to right */
  &.right {
    .popover-content {
      left: auto;
      right: 0px;
      &:before {
        left: auto;
        right: 15px;
      }
    }
  }
`;

export default PopoverWrapper;
